import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useUser } from '~/api/user';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumPostSchema } from './schemas';
import { forumPostQueryOptions } from './useForumPost';

type Payload = {
  content: string;
  title: string;
};

export const useUpdateForumPost = (id: number) => {
  const queryClient = useQueryClient();
  const { data: user } = useUser();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: post } = await fetchJson(`/forum/posts/${id}`, {
        method: 'PATCH',
        schema: apiResourceSchema(forumPostSchema),
        body,
      });

      return post;
    },
    onSuccess: (post) => {
      queryClient.setQueryData(forumPostQueryOptions(post.id).queryKey, post);
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.show.id(post.id) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.tag(null) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.tag(post.tag) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.user(user.id) });
    },
  });
};
